//export const url = 'http://localhost:3000/';

export const url = 'https://api.alivio.b612.cloud/dev/';
export const urlBanca = 'https://s5s6nqk77i.execute-api.us-east-1.amazonaws.com'
